import * as React from "react";
import "./MapFilters.css";
import Filter from "../../Assets/FilterOval.svg";
import ReplayIcon from "@mui/icons-material/Replay";
import DoneIcon from "@mui/icons-material/Done";
import Filtericon from "../../Assets/Filtericon.svg";
import FormControlSelectMap from "../FormControlMap/FormControlSelectMap";
import { APIUrlThree, APIUrlToken } from "../../Utils/Utils";
import { toast } from "react-toastify";
import axios from "axios";
export default function MapFilters({
  handleApply,
  selectDateRange,
  setSelectDateRange,
  regulationType,
  setRegulationType,
  status,
  setStatus,
  state,
  setState,
  handleReset,
  stateSelectedData,
  setStateSelectedData,
  setStatusSelectedData,
  statusSelectedData,
  dateRangeSelectedData,
  setDateRangeSelectedData,
  regulationChangeSelectedData,
  setRegulationChangeSelectedData,
}) {
  const regulationTypeDataList = [
    "legislation",
    "regulation",
    "ballot measure",
    "executive order",
    "agency document",
  ];
  const stateDataList = [
    "United States",
    "Competitive States",
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  const unitedStates = [
    "Competitive States",
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  const competitiveStatesList = [
    "Arizona",
    "California",
    "Florida",
    "Georgia",
    "Illinois",
    "Indiana",
    "Kentucky",
    "Michigan",
    "New York",
    "North Carolina",
    "Pennsylvania",
    "South Carolina",
    "Tennessee",
    "Texas",
    "Virginia",
    "West Virginia",
    "Wisconsin",
  ];

  const dateRangeDataList = ["year-to-date", "30-days", "90-days"];
  const [statusDataList, setStatusDataList] = React.useState([]);
  // State initialization

  const handleDateRange = (event) => {
    setSelectDateRange(event?.target?.value);
  };

  // const handleDateRangeData = (event, item) => {
  //   if (event.target.checked) {
  //     setDateRangeSelectedData([...dateRangeSelectedData, item]);
  //   } else {
  //     setDateRangeSelectedData(dateRangeSelectedData?.filter((uncheck) => uncheck !== item));
  //   }
  // };

  const handleDateRangeData = (event, item) => {
    if (event.target.checked) {
      setDateRangeSelectedData([item]);
    } else {
      setDateRangeSelectedData(
        dateRangeSelectedData?.filter((selectedItem) => selectedItem !== item),
      );
    }
  };

  // ---------------------
  const handleRegulationChange = (event) => {
    setRegulationType(event?.target?.value);
  };
  const handleRegulationChangeData = (event, item) => {
    if (event.target.checked) {
      setRegulationChangeSelectedData([...regulationChangeSelectedData, item]);
    } else {
      setRegulationChangeSelectedData(
        regulationChangeSelectedData?.filter((uncheck) => uncheck !== item),
      );
    }
  };
  // ------------------------

  const handleStatus = (event) => {
    setStatus(event?.target?.value);
  };

  const handleStatusData = (event, item) => {
    if (event.target.checked) {
      setStatusSelectedData([...statusSelectedData, item]);
    } else {
      setStatusSelectedData(
        statusSelectedData?.filter((uncheck) => uncheck !== item),
      );
    }
  };

  // --------------------------
  const handleState = (event) => {
    setState(event?.target?.value);
  };

  // const handleStateData = (event, item) => {
  //   if (event.target.checked) {
  //     setStateSelectedData([...stateSelectedData, item]);
  //   } else {
  //     setStateSelectedData(stateSelectedData?.filter((uncheck) => uncheck !== item));
  //   }
  // };

  const handleStateData = (event, item) => {
    if (event.target.checked) {
      if (item === "Competitive States") {
        const updatedData = Array.from(
          new Set([...stateSelectedData, item, ...competitiveStatesList]),
        );
        setStateSelectedData(updatedData);
        // } else if (item === 'United States') {
        //   const updatedData = Array.from(
        //     new Set([...stateSelectedData, item, ...unitedStates])
        //   );
        //   setStateSelectedData(updatedData);
      } else {
        setStateSelectedData([...stateSelectedData, item]);
      }
    } else {
      if (item === "Competitive States") {
        const updatedData = stateSelectedData.filter(
          (state) =>
            state !== "Competitive States" &&
            !competitiveStatesList.includes(state),
        );
        setStateSelectedData(updatedData);
        // } else if (item === 'United States') {
        //   const updatedData = stateSelectedData.filter(
        //     (state) => state !== 'United States' && !unitedStates.includes(state)
        //   );
        //   setStateSelectedData(updatedData);
      } else {
        setStateSelectedData(
          stateSelectedData.filter((uncheck) => uncheck !== item),
        );
      }
    }
  };

  // ------------------------

  const getStatusList = async () => {
    try {
      const results = await Promise.all(
        regulationChangeSelectedData?.map((i) => getOneStatusList(i)),
      );
      // Flatten the result array in case each `getOneStatusList` returns an array
      const flattenedResults = results.flat();
      setStatusDataList(flattenedResults);
    } catch (error) {
      console.error("Error fetching status list:", error);
    }
  };

  const getOneStatusList = async (item) => {
    const name =
      item?.toLowerCase() === "legislation"
        ? "legtrack"
        : item?.toLowerCase() === "regulation"
          ? "regtrack"
          : item?.toLowerCase() === "ballot measure"
            ? "ballot_measure"
            : item?.toLowerCase() === "executive order"
              ? "exec_order"
              : item?.toLowerCase() === "agency document"
                ? "rdoc"
                : null;
    if (!name) return [];

    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_status_types?document_name=${name}`,
    };

    try {
      const response = await axios(options);
      setStatus("");
      return response?.data || [];
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to fetch status types",
      );
      return [];
    }
  };

  React.useEffect(() => {
    if (
      regulationChangeSelectedData &&
      regulationChangeSelectedData.length > 0
    ) {
      getStatusList();
    } else {
      setStatus([]);
      setStatusDataList([]);
    }
  }, [regulationChangeSelectedData]);
  return (
    <React.Fragment>
      <div className="main-container-ofAi-leads-filters">
        <div className="outer-main-for-filtersand-buttons-map">
          <section className="Leads-Filter-main-container">
            <div className="AILeads-Filter1st">
              <div>
                <div className="AiLeads-filter-icons">
                  <img src={Filter} alt="" />
                </div>
                <div>
                  <img src={Filtericon} alt="" />
                </div>
              </div>
            </div>
            <div className="AILeads-Filter2nddrop-down-state">
              <FormControlSelectMap
                formControlData={{
                  value: state,
                  handleChange: handleState,
                  dataList: stateDataList,
                  handleCheckboxChange: handleStateData,
                  selectedData: stateSelectedData,
                  checked: stateSelectedData,
                }}
                placeholder="State"
              />
            </div>

            <div className="AILeads-Filter2nddrop-down-Measuretype">
              <FormControlSelectMap
                formControlData={{
                  value: regulationType,
                  handleChange: handleRegulationChange,
                  dataList: regulationTypeDataList,
                  handleCheckboxChange: handleRegulationChangeData,
                  selectedData: regulationChangeSelectedData,
                  checked: regulationChangeSelectedData,
                }}
                placeholder="Measure Type"
              />
            </div>
            {regulationChangeSelectedData.length === 1 ? (
              <div className="AILeads-Filter2nddrop-down-active">
                <FormControlSelectMap
                  formControlData={{
                    value: status,
                    handleChange: handleStatus,
                    dataList: statusDataList,
                    handleCheckboxChange: handleStatusData,
                    selectedData: statusSelectedData,
                    checked: statusSelectedData,
                  }}
                  placeholder="Status"
                />
              </div>
            ) : (
              <div className="AILeads-Filter2nddrop-down-disabled">
                <FormControlSelectMap
                  formControlData={{
                    value: status,
                    handleChange: handleStatus,
                    dataList: statusDataList,
                    handleCheckboxChange: handleStatusData,
                    selectedData: statusSelectedData,
                    checked: statusSelectedData,
                    disabled: true,
                  }}
                  placeholder="Status"
                />
              </div>
            )}

            <div className="Leads-Filter-Laststdrop-down">
              <FormControlSelectMap
                formControlData={{
                  value: selectDateRange,
                  handleChange: handleDateRange,
                  dataList: dateRangeDataList,
                  handleCheckboxChange: handleDateRangeData,
                  selectedData: dateRangeSelectedData,
                  checked: dateRangeSelectedData,
                  type: "radio",
                }}
                placeholder="Date Range"
              />
            </div>
          </section>
          <div className="legislative-apply-reset">
            <div className="apply-hit-button-map">
              <div
                className="inner-apply-button-container"
                onClick={handleApply}
              >
                <DoneIcon className="apply-tick-icon" />
                <button
                  className="AileadsFilter-Apply-button"
                  variant="contained"
                >
                  Apply
                </button>
              </div>
            </div>
            <div className="reset-hit-button" onClick={handleReset}>
              <div className="inner-rest-button-container">
                <ReplayIcon className="reset-tick-icon" />
                <button
                  className="AileadsFilter-reset-button"
                  variant="contained"
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
